import React from 'react';
import PropTypes from 'prop-types';
import AllocationUnitsGrid from 'shared/components/allocationUnitsGrid/AllocationUnitsGrid';
import { pageBackgroundGray } from 'theme/mainColors';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';

class AllocationUnitsOperations extends React.PureComponent {
  state = {
    perPage: 10,
    page: 0
  };

  componentWillMount() {
    this.props.allocationUnitsActions.fetchAllocationUnits(0, 10);
  }

  handlePageChange = (page, perPage) => {
    this.props.allocationUnitsActions.fetchAllocationUnits(page, perPage);
    this.setState({ perPage, page });
  };

  handleEditAllocationUnit = allocationId => this.props.allocationUnitsActions.fetchAllocationUnit(allocationId);

  handleDeleteAllocationUnit = allocationId => {
    const { page, perPage } = this.state;    
    this.props.allocationUnitsActions.deleteAllocationUnit(allocationId, page, perPage);    
  }

  handleCloseDialog = () => this.props.allocationUnitsActions.resetDeleteFailedFlag()

  render() {
    const { allocationUnits, totalEntries, fetchingAllocationUnits, errorMessage, deleteFailed } = this.props;
    return (
      <div className="allocation-units-operations__main-container">
        <AllocationUnitsGrid
          allocationUnitsListGridData={ allocationUnits }
          showPagination={ true }
          onPageChange={ this.handlePageChange }
          totalItems={ totalEntries }
          fetchingAllocationUnits={ fetchingAllocationUnits }
          backgroundColor={ pageBackgroundGray }
          showMoreActionsIcon={ true }
          onDeleteAllocationUnit={ this.handleDeleteAllocationUnit }
          onEditAllocationUnit={ this.handleEditAllocationUnit }
          errorMessage={ errorMessage }
          openErrorDialog={ deleteFailed }
          onCloseDialog={ this.handleCloseDialog }
        />
      </div>
    );
  }
}

AllocationUnitsOperations.propTypes = {
  allocationUnits: PropTypes.arrayOf(RULE_PROP_TYPE),
  totalEntries: PropTypes.number.isRequired,
  fetchingAllocationUnits: PropTypes.bool.isRequired,  
  allocationUnitsActions: PropTypes.shape({
    fetchAllocationUnits: PropTypes.func,
    fetchAllocationUnit: PropTypes.func,
    deleteAllocationUnit: PropTypes.func,
    resetDeleteFailedFlag: PropTypes.func
  }).isRequired,
  errorMessage: PropTypes.string,
  deleteFailed: PropTypes.bool
};

export default AllocationUnitsOperations;



// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/comp/allocationUnitsOperations/AllocationUnitsOperations.js